import React from "react";
import { NavLink } from "react-router-dom";

function Header() {
  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <ul className="list-inline shop-top-menu pb-3 pt-1">
            <li className="list-inline-item">
              <NavLink className="h3 text-dark text-decoration-none mr-3" to="/shop">
                All
              </NavLink>
            </li>
            <li className="list-inline-item">
              <NavLink className="h3 text-dark text-decoration-none mr-3" to="/shop">
                Men's
              </NavLink>
            </li>
            <li className="list-inline-item">
              <NavLink className="h3 text-dark text-decoration-none" to="/shop">
                Women's
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="col-md-6 pb-4">
          <div className="d-flex">
            <select className="form-control">
              <option>Featured</option>
              <option>A to Z</option>
              <option>Item</option>
            </select>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
